<template>
  <div v-if="staffCallFinishYn == true">
    <!-- layer -->
    <div class="dimed wrap">
      <div class="layer layer--sm layer--bottom">
        <div class="layer__body">
          <div class="ft--xlg ft--bold">
            {{ $t('Modal.StaffCall.msg7') }}
          </div>
        </div>
        <div class="layer__button">
          <button class="btn btn--xlg btn--color btn-anim" @mouseup="$emit('closeStaffCallFinish')">{{ $t('Modal.StaffCall.msg6') }}</button>
        </div>
      </div>
    </div>
    <!-- //layer -->
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'staffCallFinish',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  props: {
    staffCallFinishYn: Boolean,
  },
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    staffCallFinishYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00056', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
